import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  Input,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface TimelineStep {
  number: number;
  titleKey: string;
  descriptionKey?: string;
  link?: string;
}

@Component({
    selector: 'app-timeline-steps',
        standalone: true,
templateUrl: './timeline-steps.component.html',
    styleUrls: ['./timeline-steps.component.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineStepsComponent {
  @Input() steps: TimelineStep[] = [];
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() showDescription: boolean = true;

  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
}
